import React from 'react';
import { Badge } from 'react-bootstrap';

function PremiumGate({ message }) {
  return (
    <div className="mt-1">
      <Badge bg="warning" text="dark" className="me-1">Free Plan</Badge>
      <small className="text-muted">{message}</small>
    </div>
  );
}

export default PremiumGate;
